module.exports = __webpack_public_path__ + "media/icons/map_marker-3f3fa4d9.svg";